import { createConstantWithPrefix } from 'store/util/createReduxConstant';

const CONFIRM_MODAL_PREFIX = 'confirmModal';

export const SHOW_CONFIRM_MODAL = createConstantWithPrefix('show', CONFIRM_MODAL_PREFIX);

export const HIDE_CONFIRM_MODAL = createConstantWithPrefix('hide', CONFIRM_MODAL_PREFIX);
